import { motion } from "framer-motion";
import { NAV_LINKS } from "@/data/site";

const scrollTo = (href) => (e) => {
  e.preventDefault();
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Header() {
  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className="fixed top-0 inset-x-0 z-50 bg-background/90 backdrop-blur-md border-b border-border"
      data-testid="site-header"
    >
      <div className="flex items-stretch justify-between">
        <a
          href="#top"
          onClick={scrollTo("#top")}
          className="px-5 md:px-8 py-4 font-mono font-bold tracking-widest text-sm md:text-base border-r border-border hover:bg-muted transition-colors duration-300"
          data-testid="header-logo"
        >
          SYNCRO<span className="text-primary">/</span>87
        </a>
        <nav className="hidden md:flex items-stretch" data-testid="header-nav">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={scrollTo(l.href)}
              className="flex items-center px-6 font-mono text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground hover:bg-muted transition-colors duration-300 border-l border-border"
              data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={scrollTo("#contact")}
            className="flex items-center px-8 font-mono text-xs uppercase tracking-widest bg-primary text-primary-foreground hover:bg-foreground transition-colors duration-300 border-l border-border"
            data-testid="nav-enquire-cta"
          >
            Enquire
          </a>
        </nav>
        <a
          href="#contact"
          onClick={scrollTo("#contact")}
          className="md:hidden flex items-center px-6 font-mono text-xs uppercase tracking-widest bg-primary text-primary-foreground border-l border-border"
          data-testid="nav-enquire-cta-mobile"
        >
          Enquire
        </a>
      </div>
    </motion.header>
  );
}
